import { useBexApi } from '@shared-ui/bex-api-context';

import { useStores } from '.';
import { PageId } from '../page-identity';

export const useServicingInputs = () => {
  const { context } = useBexApi();
  const { servicingCriteriaStore, servicingConfirmationCriteriaStore, page } = useStores();
  const { flightsServicingCriteria } = servicingCriteriaStore.servicingCriteria;
  const { flightsServicingConfirmationCriteria } = servicingConfirmationCriteriaStore.servicingConfirmationCriteria;
  const criteria = [];

  switch (page.pageId) {
    case PageId.FLIGHT_SERVICING:
      criteria.push({
        context: context,
        flightsServicingCriteria: flightsServicingCriteria
      });
      break;
    case PageId.FLIGHT_SERVICING_CONFIRMATION:
      criteria.push({
        context: context,
        flightsServicingConfirmationCriteria: flightsServicingConfirmationCriteria
      });
      break;
    default:
      break;
  }

  return criteria[0];
};
